import React from 'react';
import { Spinner } from 'react-bootstrap';
import './FilterStage.css';

/**
 * Layout shell for a live camera / evaluation surface.
 *
 * It owns ONLY the arrangement of three slots — it contains no camera or ML
 * logic — so today's tan filter and a future AI evaluation tool can both render
 * into the same responsive frame.
 *
 *   camera            required: the live <canvas>/<video> node (fills the surface)
 *   controls          optional: bottom overlay on mobile, vertical side panel on tablet+
 *   results           optional: reserved region for analysis output (empty for the tan filter)
 *   busy              show a centered loading spinner over the surface
 *   controlsPlacement 'auto' (overlay <-> panel by breakpoint) | 'overlay' | 'panel'
 *   fullBleed         stretch edge-to-edge (default) vs a contained box (embedded use)
 *   onSurfaceClick    click handler forwarded to the camera region
 */
const FilterStage = ({
  camera,
  controls,
  results,
  busy = false,
  controlsPlacement = 'auto',
  fullBleed = true,
  onSurfaceClick,
}) => {
  const className = [
    'filter-stage',
    fullBleed ? 'filter-stage--bleed' : 'filter-stage--contained',
    `filter-stage--controls-${controlsPlacement}`,
  ].join(' ');

  return (
    <div className={className}>
      <div className="filter-stage__camera" onClick={onSurfaceClick}>
        {camera}
        {busy && (
          <div className="filter-stage__busy" role="status" aria-live="polite">
            <Spinner animation="border" />
          </div>
        )}
      </div>

      {controls && <div className="filter-stage__controls">{controls}</div>}
      {results && <div className="filter-stage__results">{results}</div>}
    </div>
  );
};

export default FilterStage;
